import React from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { showSignInForm, showSignUpForm, updateLogoutModalActive } from "../../redux/slices/formDetails";
import { toggleModal } from "../../redux/slices/preview";
import { selectUserActivity } from "../../redux/slices/userActivity";

import PublishButton from "../PublishButton/publishButton";
import UserProfile from "./UserProfile.js/userProfile";

export default function NavButtons({ handleClick, handleNavigate, width }) {
  const location = useLocation();
  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector((state) => state.user);
  const [error, setError] = useState(false)
  const { videoVisible, isVideo } = useSelector((state) => state.userActivity);

  const handlePreview = () => {
    if(isVideo){
      dispatch(selectUserActivity(0))
    }
    dispatch(toggleModal());
  };

  return (
    <div className="navbar-container__buttons">
      {!isLoggedIn ? (
        <button
          onClick={() => {
            handleClick();
            dispatch(showSignInForm());
          }}
          className="btn-secondary sign-in-btn"
        >
          Sign in
        </button>
      ) : (
        <>
          <button
            onClick={() => {
              dispatch(updateLogoutModalActive(true));
            }}
            className="btn-secondary sign-in-btn "
            style={{ marginRight: isLoggedIn ? "0.5rem" : "1rem" }}
          >
            Sign out
          </button>
        </>
      )}
      {
        isLoggedIn && location.pathname.substring(0, 7) !== "/design" && (
          <UserProfile />
        )}
      {location.pathname.substring(0, 7) === "/design" ? (
        <>
          <img src="/assets/icons/download.svg" className="mr-4" alt="download" onClick={() => handleNavigate("/pdf")} style={{ cursor: "pointer" }} />
          <button className="btn-secondary mr-4 nav-button" onClick={handlePreview}>
            Preview
          </button>
          {
            width >= 1100 &&
            <PublishButton className='nav-button btn-primary ' setError={setError} />
          }
        </>
      ) : (
        <>
          {!isLoggedIn && (
            <button
              onClick={() => {
                handleClick();
                dispatch(showSignUpForm());
              }}
              className="btn-primary"
            >
              Sign up
            </button>
          )}
        </>
      )}
    </div>
  );
}
